/**
 * Background color for the journey touchpoint timeline.
 * Keep in sync with widget-chart.component.scss (.content--journey-touchpoints).
 */
export const JOURNEY_TIMELINE_BG = '#eef1f4';
export function resolveJourneyChannelIcon(channelLabel: string | undefined): string {
  const label = (channelLabel ?? '').toLowerCase();
  if (label.includes('survey')) {
    return 'kxi-icon-document_survey_filled';
  }
  if (label.includes('mail')) {
    return 'kxi-icon-email_filled';
  }
  if (
    label.includes('phone') ||
    label.includes('call') ||
    label.includes('transcript') ||
    label.includes('sms') ||
    label.includes('text') ||
    label.includes('chat')
  ) {
    return 'kxi-icon-mobile_filled';
  }
  if (label.includes('person')) {
    return 'kxi-icon-users_filled';
  }
  return 'kxi-icon-document_filled';
}

export function getJourneyChannelLabel(
  channelId: string | undefined,
  labelMap: Record<string, string>,
  parentMap: Record<string, string>
): string {
  if (!channelId) {
    return '';
  }
  const labels: string[] = [];
  let currentId: string | undefined = channelId;
  while (currentId) {
    if (labelMap[currentId]) {
      labels.push(labelMap[currentId]);
    }
    currentId = parentMap[currentId];
  }
  return labels.join(' ');
}
